import React from 'react';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const Body = React.lazy(() => import('@views/orders/fields/products/extra_row/tech-process/Body'));

export default function LazyBody(props: React.ComponentProps<typeof Body>) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <Body {...props}/>
    </React.Suspense>;
}
